export default __webpack_public_path__ + "static/ship-06945687bfafdc6a60a44c94d2617ec0.webp";